import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { LoadType } from 'src/app/core/models/load-type';
import { LoadTypeService } from 'src/app/core/services/general/load-type.service';

@Component({
  selector: 'app-load-type-input',
  templateUrl: './load-type-input.component.html',
  styleUrls: ['./load-type-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: LoadTypeInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: LoadTypeInputComponent,
    },
  ],
})
export class LoadTypeInputComponent {
  @Input()
  title = "Select Cargo Category...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public loadTypesList: Array<CustomSelectOption> = [];

  constructor(
    private loadTypeService: LoadTypeService,
  ) {
    this.loadTypeService
      .all()
      .subscribe((res: Array<LoadType>) => {
        this.loadTypesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.loadTypesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
